import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[finaBlurOnWheel]',
})
export class BlurOnWheelDirective {
    constructor(private el: ElementRef) {}

    @HostListener('wheel', ['$event'])
    onWheel(event: WheelEvent) {
        const element = this.el.nativeElement as HTMLInputElement;
        if (element && typeof element.blur === 'function') {
            element.blur();
        }
    }
}
